import { Flex } from '@buffer-mono/popcorn'
import { clsx } from 'clsx'
import { useIsScrolled } from '~publish/hooks/useIsScrolled'
import { PostItem } from './PostItem'
import type { ListItem } from './PostItems'
import styles from './PostItems.module.css'

export const PostItemList = ({ items }: { items: ListItem[] }): JSX.Element => {
  const { scrollRef, isScrolled } = useIsScrolled<HTMLOListElement>()

  return (
    <Flex
      ref={scrollRef}
      as="ol"
      direction="column"
      justify="start"
      align="start"
      gap="sm"
      className={clsx(styles.listContainer, isScrolled && styles.scrolled)}
      fullWidth
      fullHeight
    >
      {items.map((item, index) => (
        <PostItem key={item.id} item={item} index={index} />
      ))}
    </Flex>
  )
}
